import React from 'react';
import PropTypes from 'prop-types';
import { FormCardSpaced } from 'modules/common';
import { AcceptButton, EnhancedUpsell, UpsellName, UpsellAction, Widgets, VoteProSettings } from './sections';
import { WIDGETS_MAP } from 'modules/common/widgets/tools';

function VoteProUpsell(props) {
  return (
    <>
      <FormCardSpaced>
        <UpsellName {...props} />
        <UpsellAction {...props} />
        <AcceptButton {...props} />
      </FormCardSpaced>

      <FormCardSpaced
        title="VotePro"
        subtitle="Choose whether to pre-fill the donor, which method to open, and an optional end date."
      >
        <VoteProSettings editedUpsell={props.editedUpsell} onUpdateEditedUpsell={props.onUpdateEditedUpsell} />
      </FormCardSpaced>

      <EnhancedUpsell {...props} />

      <Widgets
        {...props}
        widgetOptions={VoteProUpsell.widgets}
        primaryColor={props.primaryColor}
        secondaryColor={props.secondaryColor}
      />
    </>
  );
}

VoteProUpsell.title = 'VotePro';
VoteProUpsell.description = 'Let donors check their registration or make a plan to vote.';
VoteProUpsell.icon = 'upsell-votepro';
VoteProUpsell.type = 'VOTEPRO';
VoteProUpsell.widgets = [
  WIDGETS_MAP.EXITINTENTPOPUP.value,
  WIDGETS_MAP.SHOTCLOCK.value,
  WIDGETS_MAP.COUNTDOWN.value,
  WIDGETS_MAP.COUNTDOWNTOMIDNIGHT.value,
  WIDGETS_MAP.SOCIALLINKS.value,
  WIDGETS_MAP.CONFETTI.value,
];

VoteProUpsell.propTypes = {
  editedUpsell: PropTypes.object.isRequired,
  onUpdateEditedUpsell: PropTypes.func.isRequired,
  primaryColor: PropTypes.string,
  secondaryColor: PropTypes.string,
};

export default VoteProUpsell;
